<template>
    <section id="about-electrologist" class="blog-author section">
        <div class="container">
            <div class="author-container d-flex align-items-center">
                <img src="/media/lead-electrologist.jpg" class="rounded-circle flex-shrink-0" alt="Lead Electrologist">
                <div class="blog-details content">
                    <h3>Meet Your Electrologist</h3>
                    <p>
                        With close to 10 years of experience, our certified electrologist has helped countless clients achieve their permanent hair removal goals. She specializes in providing comfortable and effective treatments for all skin types and hair colors.
                        <br/>Having personally dealt with PCOS and struggled with unwanted facial hair since her teenage years, she deeply understands the challenges her clients face. She is dedicated to offering compassionate, individualized care to help clients feel confident and comfortable throughout their journey.
                    </p>

                    <blockquote>
                        <p>
                            "My mission is to help each client feel confident and comfortable throughout their
                            electrolysis journey, ensuring the best possible results."
                        </p>
                    </blockquote>

                    <h3>Certifications & Training</h3>
                    <p>
                        Licensed by the State Board of Cosmetology and certified by the American Electrology Association, our electrologist is also a master aesthetician. 
                        She continues to stay current with the latest techniques and technology in permanent hair removal, ensuring the highest standard of care for her clients.
                    </p>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: 'AboutElectrologist'
}
</script>